import { ValidationProvider, extend } from 'vee-validate';
import { 
  required, 
  max, 
  max_value,
  min_value,
  email,
  min,
  confirmed,
  regex,
  alpha_num,
  numeric
} from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: '{_field_} harus diisi'
});

extend('min', {
  ...min,
  params: ['length'],
  message: '{_field_} harus setidaknya {length} karakter'
});

extend('max', {
  ...max,
  params: ['length'],
  message: '{_field_} maksimum {length} karakter'
});

extend('max_value', {
  ...max_value,
  message: '{_field_} seharusnya {max} atau kurang'
});

extend('min_value', {
  ...min_value,
  message: '{_field_} seharusnya {min} atau lebih'
});

extend('email', {
  ...email,
  message: '{_field_} harus berupa email'
});

extend('confirmed', {
  ...confirmed,
  message: 'Konfirmasi password baru tidak sama'
});

extend('regex', {
  ...regex,
  message: '{_field_} tidak sesuai'
});

extend('alpha_num', {
  ...alpha_num,
  message: '{_field_} hanya boleh mengandung karakter alfanumerik'
});

extend('numeric', {
  ...numeric,
  message: '{_field_} harus berupa angka'
});

export default ValidationProvider